import { useProjects } from '@cascade/react/projects';
import { useNps } from '@cascade/react-dom/hooks';
import { readStorageItem, writeStorageItem } from '@cascade/react-dom/utils';
import { useCallback } from 'react';
import type { TNpsSurvey } from './useNpsSurvey.types.ts';
import {
  IS_PRODUCTION,
  NPS_SURVEY_ID,
  NPS_WORKSPACE_ID,
} from '#config/index.ts';

const ASKED_KEY = 'cascade.nps.asked';

let hasAskedThisLoad = false;

export const useNpsSurvey = (): TNpsSurvey => {
  const { isFeatureEnabled } = useProjects();

  const isEnabled = IS_PRODUCTION && isFeatureEnabled('enable_nps');

  const { startSurvey } = useNps({ isEnabled, workspaceId: NPS_WORKSPACE_ID });

  const startSurveyOnce = useCallback(() => {
    if (!isEnabled || hasAskedThisLoad) {
      return;
    }

    const askedMark = readStorageItem(ASKED_KEY, { storage: 'session' });

    if (askedMark) {
      return;
    }

    hasAskedThisLoad = true;
    writeStorageItem(ASKED_KEY, 'true', { storage: 'session' });
    startSurvey(NPS_SURVEY_ID);
  }, [isEnabled, startSurvey]);

  return { startSurvey: startSurveyOnce };
};
